import React from 'react';
import { Link } from 'react-router-dom';
import { NumberInput, errorClassName } from './Inputs';
import { formatMoney } from '../formatMoney';

const DesktopRow = ({ row, index, errors, isEditable, onChange }) => {
  return (
    <div className={`grid grid-cols-[80px_140px_160px_120px_100px_160px_120px_160px] items-center gap-3 border-b border-slate-200 px-4 py-3 last:border-b-0 ${!row.include ? 'bg-slate-50/70' : ''}`}>
      <div className="flex items-center justify-start">
        <input
          type="checkbox"
          checked={row.include === true}
          onChange={(e) => onChange(row.id, 'include', e.target.checked)}
          disabled={!isEditable}
          className="h-4 w-4 rounded border-slate-300 text-orange-600 focus:ring-orange-200 disabled:cursor-not-allowed"
          aria-label={`Include ${row.plate_no || `row ${index + 1}`}`}
        />
      </div>

      <div className="min-w-0">
        {row.plate_no ? (
          <Link
            to={`/cars/${encodeURIComponent(row.plate_no)}`}
            className={`block truncate text-sm font-semibold hover:underline ${row.include === false ? 'text-slate-400 line-through' : 'text-orange-600'}`}
            title={row.plate_no}
          >
            {row.plate_no}
          </Link>
        ) : (
          <span className={`block truncate text-sm font-semibold ${row.include === false ? 'text-slate-400 line-through' : 'text-orange-600'}`} title={row.plate_no}>
            -
          </span>
        )}
      </div>

      <div className="min-w-0">
        <span className={`block text-sm ${row.include === false ? 'text-slate-400' : 'text-slate-600'}`}>
          {row.allocation_date || '-'}
        </span>
      </div>

      <div>
        <NumberInput
          value={row.base_amount}
          onChange={(e) => onChange(row.id, 'base_amount', e.target.value)}
          disabled={!isEditable || row.include === false}
          placeholder="0.00"
          className="!h-10 !rounded-lg !text-center"
        />
      </div>

      <div>
        <NumberInput
          step="1"
          value={row.days_counted}
          onChange={(e) => onChange(row.id, 'days_counted', e.target.value)}
          disabled={!isEditable || row.include === false}
          placeholder="0"
          className="!h-10 !rounded-lg !text-center"
        />
      </div>

      <div className="text-right text-sm font-semibold text-slate-900">
        {formatMoney(row.gross_amount)}
      </div>

      <div>
        <NumberInput
          value={row.discount_amount}
          onChange={(e) => onChange(row.id, 'discount_amount', e.target.value)}
          disabled={!isEditable || row.include === false}
          className={`${errors.discount_amount ? errorClassName : ''} !h-10 !rounded-lg !text-center`}
          placeholder="0.00"
        />
        {errors.discount_amount && <div className="mt-1 text-xs text-rose-600">{errors.discount_amount}</div>}
      </div>

      <div className="text-right text-sm font-semibold text-slate-900">
        {formatMoney(row.prorated_amount)}
      </div>
    </div>
  );
};

export default DesktopRow;
